import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(auth)/auth/login/client.tsx");
